// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Pricing page (no site header on this page) */
.pp-page {
  --pp-bg: #f5f7fb;
  --pp-card: #ffffff;
  --pp-text: #0f172a;
  --pp-muted: #64748b;
  --pp-border: #e2e8f0;
  --pp-accent: #2b5fae;
  --pp-accent-2: #1e4a8c;
  --pp-green: #2e8b3d;
  min-height: 100vh;
  background: var(--pp-bg);
  color: var(--pp-text);
  padding: 0 16px 48px;
}
.dark .pp-page {
  --pp-bg: #0b1220;
  --pp-card: #111a2e;
  --pp-text: #e2e8f0;
  --pp-muted: #94a3b8;
  --pp-border: #1f2a44;
  --pp-accent: #4f8be8;
  --pp-accent-2: #3a74d1;
}

.pp-topbar {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 0;
}
.pp-menu { width: auto !important; }
.pp-menu button { color: var(--pp-text); }
.pp-logo img { height: 44px; display: block; }
.pp-topbar > :last-child { margin-left: auto; }

.pp-hero { text-align: center; max-width: 720px; margin: 24px auto 40px; }
.pp-eyebrow {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 999px;
  background: rgba(43, 95, 174, 0.1);
  color: var(--pp-accent);
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}
.pp-hero h1 { margin: 14px 0 10px; font-size: clamp(26px, 4vw, 40px); font-weight: 700; line-height: 1.2; }
.pp-hero p { margin: 0; color: var(--pp-muted); font-size: 17px; }

.pp-grid {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 20px;
}
.pp-card {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 28px 24px 24px;
  background: var(--pp-card);
  border: 1px solid var(--pp-border);
  border-radius: 16px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 8px 24px rgba(15, 23, 42, 0.06);
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}
.pp-card:hover {
  transform: translateY(-4px);
  border-color: var(--pp-accent);
  box-shadow: 0 16px 36px rgba(43, 95, 174, 0.16);
}
.pp-card--best { border: 2px solid var(--pp-accent); }
.pp-badge {
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  padding: 4px 12px;
  border-radius: 999px;
  background: var(--pp-green);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}
.pp-plan { margin: 0 0 16px; font-size: 15px; font-weight: 700; letter-spacing: 0.04em; color: var(--pp-muted); }
.pp-price { display: flex; align-items: flex-start; gap: 2px; color: var(--pp-text); }
.pp-currency { font-size: 22px; font-weight: 600; margin-top: 6px; }
.pp-amount { font-size: 44px; font-weight: 800; line-height: 1; }
.pp-validity { margin: 10px 0 20px; color: var(--pp-muted); font-size: 14px; line-height: 1.5; }
.pp-daily { color: var(--pp-green); font-weight: 600; }
.pp-features { list-style: none; margin: 0 0 24px; padding: 20px 0 0; border-top: 1px solid var(--pp-border); flex: 1 1; }
.pp-features li { display: flex; gap: 10px; align-items: flex-start; margin-bottom: 10px; font-size: 15px; }
.pp-features li i { color: var(--pp-green); margin-top: 3px; }
.pp-subscribe {
  width: 100%;
  padding: 12px 16px;
  border: none;
  border-radius: 10px;
  background: var(--pp-accent);
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  cursor: pointer;
  transition: background 0.2s ease;
}
.pp-subscribe:hover { background: var(--pp-accent-2); }
.pp-subscribe:focus-visible { outline: 3px solid rgba(43, 95, 174, 0.4); outline-offset: 2px; }
.pp-empty { grid-column: 1 / -1; text-align: center; color: var(--pp-muted); }

.pp-links {
  max-width: 1200px;
  margin: 48px auto 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
}
.pp-links a {
  padding: 10px 18px;
  border-radius: 10px;
  border: 1px solid var(--pp-border);
  background: var(--pp-card);
  color: var(--pp-text);
  font-weight: 600;
  text-decoration: none;
}
.pp-links a:hover { border-color: var(--pp-accent); color: var(--pp-accent); }

@media (max-width: 575px) {
  .pp-amount { font-size: 38px; }
  .pp-card { padding: 24px 18px 20px; }
}
`, "",{"version":3,"sources":["webpack://./src/component/front/Pricing.css"],"names":[],"mappings":"AAAA,+CAA+C;AAC/C;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,wBAAwB;EACxB,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA,WAAW,sBAAsB,EAAE;AACnC,kBAAkB,qBAAqB,EAAE;AACzC,eAAe,YAAY,EAAE,cAAc,EAAE;AAC7C,2BAA2B,iBAAiB,EAAE;;AAE9C,WAAW,kBAAkB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE;AACzE;EACE,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,kCAAkC;EAClC,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA,cAAc,mBAAmB,EAAE,iCAAiC,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AAC1G,aAAa,SAAS,EAAE,sBAAsB,EAAE,eAAe,EAAE;;AAEjE;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,kCAAkC;EAClC,mBAAmB;EACnB,+EAA+E;EAC/E,6EAA6E;AAC/E;AACA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,+CAA+C;AACjD;AACA,iBAAiB,kCAAkC,EAAE;AACrD;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,oBAAoB;EACpB,2BAA2B;EAC3B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA,WAAW,gBAAgB,EAAE,eAAe,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,sBAAsB,EAAE;AAChH,YAAY,aAAa,EAAE,uBAAuB,EAAE,QAAQ,EAAE,qBAAqB,EAAE;AACrF,eAAe,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE;AACnE,aAAa,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAChE,eAAe,mBAAmB,EAAE,sBAAsB,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC/F,YAAY,sBAAsB,EAAE,gBAAgB,EAAE;AACtD,eAAe,gBAAgB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,sCAAsC,EAAE,SAAO,EAAE;AACvH,kBAAkB,aAAa,EAAE,SAAS,EAAE,uBAAuB,EAAE,mBAAmB,EAAE,eAAe,EAAE;AAC3G,oBAAoB,sBAAsB,EAAE,eAAe,EAAE;AAC7D;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,gCAAgC;AAClC;AACA,sBAAsB,8BAA8B,EAAE;AACtD,8BAA8B,yCAAyC,EAAE,mBAAmB,EAAE;AAC9F,YAAY,mBAAmB,EAAE,kBAAkB,EAAE,sBAAsB,EAAE;;AAE7E;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;AACvB;AACA,oBAAoB,8BAA8B,EAAE,uBAAuB,EAAE;;AAE7E;EACE,aAAa,eAAe,EAAE;EAC9B,WAAW,uBAAuB,EAAE;AACtC","sourcesContent":["/* Pricing page (no site header on this page) */\n.pp-page {\n  --pp-bg: #f5f7fb;\n  --pp-card: #ffffff;\n  --pp-text: #0f172a;\n  --pp-muted: #64748b;\n  --pp-border: #e2e8f0;\n  --pp-accent: #2b5fae;\n  --pp-accent-2: #1e4a8c;\n  --pp-green: #2e8b3d;\n  min-height: 100vh;\n  background: var(--pp-bg);\n  color: var(--pp-text);\n  padding: 0 16px 48px;\n}\n.dark .pp-page {\n  --pp-bg: #0b1220;\n  --pp-card: #111a2e;\n  --pp-text: #e2e8f0;\n  --pp-muted: #94a3b8;\n  --pp-border: #1f2a44;\n  --pp-accent: #4f8be8;\n  --pp-accent-2: #3a74d1;\n}\n\n.pp-topbar {\n  max-width: 1200px;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 16px 0;\n}\n.pp-menu { width: auto !important; }\n.pp-menu button { color: var(--pp-text); }\n.pp-logo img { height: 44px; display: block; }\n.pp-topbar > :last-child { margin-left: auto; }\n\n.pp-hero { text-align: center; max-width: 720px; margin: 24px auto 40px; }\n.pp-eyebrow {\n  display: inline-block;\n  padding: 4px 12px;\n  border-radius: 999px;\n  background: rgba(43, 95, 174, 0.1);\n  color: var(--pp-accent);\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n.pp-hero h1 { margin: 14px 0 10px; font-size: clamp(26px, 4vw, 40px); font-weight: 700; line-height: 1.2; }\n.pp-hero p { margin: 0; color: var(--pp-muted); font-size: 17px; }\n\n.pp-grid {\n  max-width: 1200px;\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 20px;\n}\n.pp-card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  padding: 28px 24px 24px;\n  background: var(--pp-card);\n  border: 1px solid var(--pp-border);\n  border-radius: 16px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 8px 24px rgba(15, 23, 42, 0.06);\n  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n}\n.pp-card:hover {\n  transform: translateY(-4px);\n  border-color: var(--pp-accent);\n  box-shadow: 0 16px 36px rgba(43, 95, 174, 0.16);\n}\n.pp-card--best { border: 2px solid var(--pp-accent); }\n.pp-badge {\n  position: absolute;\n  top: -12px;\n  left: 50%;\n  transform: translateX(-50%);\n  padding: 4px 12px;\n  border-radius: 999px;\n  background: var(--pp-green);\n  color: #fff;\n  font-size: 12px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n.pp-plan { margin: 0 0 16px; font-size: 15px; font-weight: 700; letter-spacing: 0.04em; color: var(--pp-muted); }\n.pp-price { display: flex; align-items: flex-start; gap: 2px; color: var(--pp-text); }\n.pp-currency { font-size: 22px; font-weight: 600; margin-top: 6px; }\n.pp-amount { font-size: 44px; font-weight: 800; line-height: 1; }\n.pp-validity { margin: 10px 0 20px; color: var(--pp-muted); font-size: 14px; line-height: 1.5; }\n.pp-daily { color: var(--pp-green); font-weight: 600; }\n.pp-features { list-style: none; margin: 0 0 24px; padding: 20px 0 0; border-top: 1px solid var(--pp-border); flex: 1; }\n.pp-features li { display: flex; gap: 10px; align-items: flex-start; margin-bottom: 10px; font-size: 15px; }\n.pp-features li i { color: var(--pp-green); margin-top: 3px; }\n.pp-subscribe {\n  width: 100%;\n  padding: 12px 16px;\n  border: none;\n  border-radius: 10px;\n  background: var(--pp-accent);\n  color: #fff;\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition: background 0.2s ease;\n}\n.pp-subscribe:hover { background: var(--pp-accent-2); }\n.pp-subscribe:focus-visible { outline: 3px solid rgba(43, 95, 174, 0.4); outline-offset: 2px; }\n.pp-empty { grid-column: 1 / -1; text-align: center; color: var(--pp-muted); }\n\n.pp-links {\n  max-width: 1200px;\n  margin: 48px auto 0;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 12px;\n}\n.pp-links a {\n  padding: 10px 18px;\n  border-radius: 10px;\n  border: 1px solid var(--pp-border);\n  background: var(--pp-card);\n  color: var(--pp-text);\n  font-weight: 600;\n  text-decoration: none;\n}\n.pp-links a:hover { border-color: var(--pp-accent); color: var(--pp-accent); }\n\n@media (max-width: 575px) {\n  .pp-amount { font-size: 38px; }\n  .pp-card { padding: 24px 18px 20px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
